import React from 'react'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

interface CustomCKEditorProps {
  data: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (event: any, editor: ClassicEditor) => void | undefined
}

const CustomEditor: React.FC<CustomCKEditorProps> = ({ data, onChange }) => {
  return (
    <div className="no-tailwind">
      <CKEditor
        editor={ClassicEditor}
        data={data}
        onChange={onChange}
        config={{
          toolbar: [
            'undo',
            'redo',
            '|',
            'heading',
            '|',
            'fontfamily',
            'fontsize',
            'fontColor',
            'fontBackgroundColor',
            '|',
            'bold',
            'italic',
            'strikethrough',
            'subscript',
            'superscript',
            'code',
            '|',
            'link',
            'blockQuote',
            'codeBlock',
            '|',
            'bulletedList',
            'numberedList',
            'todoList',
            'outdent',
            'indent',
          ],
        }}
      />
    </div>
  )
}

export default CustomEditor
